<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <a v-if="urlDownload.length > 0" class="btn-primary float-right mt-4" :href="urlDownload" download="Labels.csv"><feather-icon icon="DownloadCloudIcon" /></a>
    <vs-table v-if="response" ref="table" :data="response">
      <template>
        <tbody>
         <tr :key="index" @click="goToDetail(item.id_label)" class="tr-values vs-table--tr tr-table-state-null selected" v-for="(item, index) in response">
            <listItem
              :value="item.alias_label"
              :description="$t('Labels.Alias')"
              img="label"
            ></listItem>
            <listItem
              v-if="item.alias_device"
              :value="item.alias_device"
              :description="$tc('Devices',1)"
              img="cpu"
            ></listItem>
            <vs-td v-else>
              <div class="device-info" >
                  <div class="device-text-container">
                    <span class="main-info">{{$t('Labels.NotAssigned')}}</span>
                  </div>
              </div>
            </vs-td>
        </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'

export default {
  components: {
    listItem
  },
  data () {
    return {
      response: [],
      urlDownload: '',
      types: {
        F: 'Flujo de Aire',
        T: 'Temperatura y Humedad',
        E: 'Energía',
        P: 'Puertas',
        A: 'Agro'
      }
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'modelo/labels',
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.createCsv()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/labels/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push('Alias')
      headers.push('Dispositivo')
      headers.push('Tipo')
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.alias_label)
        row.push(item.alias_device)
        row.push(this.types[item.device_type])
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
